import { render, staticRenderFns } from "./CreatePO.vue?vue&type=template&id=2aec1dec&scoped=true"
import script from "./CreatePO.vue?vue&type=script&lang=js"
export * from "./CreatePO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec1dec",
  null
  
)

export default component.exports